// extracted by mini-css-extract-plugin
module.exports = {"firstStripe":"Story_firstStripe__3ExO7","story":"Story_story__24Q3R"};